module.exports = __webpack_public_path__ + "static/img/3.841e36d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/trainPlan/10sportDesc/3.svg
// module id = vca0
// module chunks = 0